import React from "react";

import { MascotFrame, skinTones } from "./MascotFrame";

export function ProsperoArt({ className }: { className?: string }) {
  return (
    <MascotFrame
      className={className}
      backdropClassName="bg-mascot-backdrop-teal"
    >
      <path
        d="M10.5 15v33"
        className="stroke-yellow-800"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="10.5" cy="13" r="2.6" className="fill-yellow-400" />
      <path d="M9 48c0-10 6.5-15 15-15s15 5 15 15z" className="fill-blue-800" />
      <g className="fill-teal-300">
        <circle cx="13.5" cy="42" r=".8" />
        <circle cx="34.5" cy="39.5" r=".8" />
        <circle cx="35.5" cy="45.5" r=".7" />
        <circle cx="12.5" cy="46.5" r=".7" />
      </g>
      <ellipse cx="24" cy="33.5" rx="6.5" ry="2.2" className="fill-white" />
      <circle cx="24" cy="24" r="7" className={skinTones.deep} />
      <path
        d="M18 26c.5 5 3 8 6 8s5.5-3 6-8c-1.5 1.5-3.5 2.2-6 2.2S19.5 27.5 18 26z"
        className="fill-gray-300"
      />
      <path
        d="M20 27.4c1.5-1.3 3-1.3 4 0 1-1.3 2.5-1.3 4 0-1.3 1.2-2.8 1.4-4 .4-1.2 1-2.7.8-4-.4z"
        className="fill-gray-300"
      />
      <circle cx="21.3" cy="23.8" r=".9" className="fill-gray-900" />
      <circle cx="26.7" cy="23.8" r=".9" className="fill-gray-900" />
      <path
        d="M16.5 21c0-5 3.3-8 7.5-8s7.5 3 7.5 8c-2.3-1.2-4.8-1.8-7.5-1.8s-5.2.6-7.5 1.8z"
        className="fill-red-700"
      />
      <path
        d="M14.5 38.5c3-1 6-.8 9.2.8v8.2c-3.2-1.6-6.2-1.8-9.2-.8zm19 0c-3-1-6-.8-9.2.8v8.2c3.2-1.6 6.2-1.8 9.2-.8z"
        className="fill-white"
      />
      <path
        d="M16.5 41.5c1.7-.4 3.5-.3 5.2.3m-5.2 2.2c1.7-.4 3.5-.3 5.2.3"
        className="fill-none stroke-gray-300"
        strokeWidth=".9"
        strokeLinecap="round"
      />
      <path
        d="m26.6 42.6 1.8 1.8 3.4-3.8"
        className="fill-none stroke-teal-700"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14.5" cy="42.5" r="1.7" className={skinTones.deep} />
      <circle cx="33.5" cy="42.5" r="1.7" className={skinTones.deep} />
    </MascotFrame>
  );
}
